module.exports = __webpack_public_path__ + "img/nodeType3.bbccc756.svg";